<div class="background glass ps-4 pt-4">

    <div class="mb-2">Select a reaction</div>

    <div class="d-flex justify-content-center align-items-center">
        <emoji-mart
                (emojiClick)="selectEmoji($event)"
                title="Pick your emoji…" emoji="heart"
        ></emoji-mart>
        <span class="emoji mx-3 my-3">{{selectedEmoji}}</span>
    </div>
    <div class="mt-3 d-flex justify-content-end w-100 mb-3 me-2 pe-4">
        <button class="btn-out me-2" (click)="closeHolder()">Cancel</button>
        <button class="btn-primary" (click)="post()" [disabled]="selectedEmoji.length === 0">
            React
        </button>
    </div>
</div>
